import attendService from './attendService';

const _loadQueue = () => {
  return JSON.parse(localStorage.getItem('attendSaveQueue')) || [];
};
const _saveQueue = (queue) => {
  localStorage.setItem('attendSaveQueue', JSON.stringify(queue));
};
let gQueue = _loadQueue();
let gIsPlaying = false;

const addToQueue = (empId, date) => {
  console.log('Adding to queue:', empId, date);
  gQueue.push({ empId, date });
  _saveQueue(gQueue);
};

const playQueue = async () => {
  if (gIsPlaying) return;
  while (gQueue.length) {
    gIsPlaying = true;
    const item = gQueue.shift();
    const { empId, date } = item;
    console.log('Playing queue:', empId, date);

    try {
      await attendService.updateEmpAttendByDate(empId, date);
    } catch (err) {
      console.error('attendSaveQueue error:', err);
      gQueue.push(item);
    }
    _saveQueue(gQueue);
  }

  gIsPlaying = false;
};
export default {
  addToQueue,
  playQueue,
};
